import { render, staticRenderFns } from "./DepaIncome.vue?vue&type=template&id=3e89de48"
import script from "./DepaIncome.vue?vue&type=script&lang=js"
export * from "./DepaIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports